import React from 'react';

export function PageLoadingSkeleton() {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-slate-900">
      <div className="max-w-7xl mx-auto px-4 py-8">
        <div className="animate-pulse space-y-6">
          <div className="h-12 bg-gray-200 dark:bg-slate-700 rounded w-1/2"></div>
          <div className="h-6 bg-gray-200 dark:bg-slate-700 rounded w-3/4"></div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {[...Array(6)].map((_, i) => (
              <div key={i} className="bg-white dark:bg-slate-800 rounded-lg shadow-sm p-6">
                <div className="h-6 bg-gray-200 dark:bg-slate-700 rounded mb-2"></div>
                <div className="h-4 bg-gray-100 dark:bg-slate-600 rounded mb-4"></div>
                <div className="h-4 bg-gray-100 dark:bg-slate-600 rounded w-1/2"></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}